import logo from "../../../assets/images/logo.svg";
import { Login } from "../Dialogs/Login"
import { Register } from "../Dialogs/Register"

export default function Navbar() {
    return (
        <div className="bg-brand-darkest sticky top-0 z-50 sm:-ml-4 sm:-mr-4 max-w-screen">
            <div className="px-2 lg:px-32 py-4">
                <div className="justify-between items-center flex">
                    <div className="flex items-end gap-2 hover:cursor-pointer" onClick={() => window.location.href = '/'}>
                        <div className="flex items-center gap-1">
                            <img src={logo} alt="logo" className="w-10 h-10" />
                            <h1 className="text-xl text-white font-bold italic">
                                Teamly
                            </h1>
                        </div>
                        <div className="text-sm rounded font-bold bg-gray-600 px-1 items-end bg-gradient-to-br from-brand-green to-brand-green/50">
                            <p>BETA</p>
                        </div>
                    </div>
                    <div className="flex items-center space-x-4 text-lg">
                        <Register>
                            <button className="text-white">Register</button>
                        </Register>
                        <Login>
                            <button className="text-brand-green font-bold text-shadow-brand">Login</button>
                        </Login>
                    </div>
                </div>
            </div>
        </div>
    );
}
